module.exports = __webpack_public_path__ + "media/images/pc/stores/sola/sola_symbol-367b707f26888196ad1a55fe5ae14300.svg";